import _defineProperty from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React__default from 'react';
import classNames from 'classnames';
var FirstLetterIcon = function FirstLetterIcon(_ref) {
  var word = _ref.word,
    _ref$customModifier = _ref.customModifier,
    customModifier = _ref$customModifier === void 0 ? "" : _ref$customModifier;
  var firstLetter = word.charAt(0);
  var componentClass = classNames("header-cp__letter-circle", _defineProperty({}, "header-cp__letter-circle--".concat(customModifier), !!customModifier));
  return /* @__PURE__ */React__default.createElement("div", {
    className: componentClass
  }, firstLetter);
};
export { FirstLetterIcon as default };